import React from 'react'

export const FiltersIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="13"
    viewBox="0 0 18 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2143 0.0715332C10.6668 0.0715332 9.36543 1.18073 9.06529 2.64296H0.642857C0.28782 2.64296 0 2.93078 0 3.28582C0 3.64086 0.28782 3.92868 0.642857 3.92868H9.06529C9.36543 5.39091 10.6668 6.5001 12.2143 6.5001C13.7618 6.5001 15.0631 5.39091 15.3633 3.92868H17.3571C17.7122 3.92868 18 3.64086 18 3.28582C18 2.93078 17.7122 2.64296 17.3571 2.64296H15.3633C15.0631 1.18073 13.7618 0.0715332 12.2143 0.0715332ZM12.2143 1.35725C13.287 1.35725 14.1429 2.2131 14.1429 3.28582C14.1429 4.35854 13.287 5.21439 12.2143 5.21439C11.1416 5.21439 10.2857 4.35854 10.2857 3.28582C10.2857 2.2131 11.1416 1.35725 12.2143 1.35725Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.78571 6.5C4.23823 6.5 2.93686 7.60919 2.63672 9.07143H0.642857C0.28782 9.07143 0 9.35925 0 9.71429C0 10.0693 0.28782 10.3571 0.642857 10.3571H2.63672C2.93686 11.8194 4.23823 12.9286 5.78571 12.9286C7.33319 12.9286 8.63457 11.8194 8.93471 10.3571H17.3571C17.7122 10.3571 18 10.0693 18 9.71429C18 9.35925 17.7122 9.07143 17.3571 9.07143H8.93471C8.63457 7.60919 7.33319 6.5 5.78571 6.5ZM5.78571 7.78571C6.85843 7.78571 7.71429 8.64157 7.71429 9.71429C7.71429 10.787 6.85843 11.6429 5.78571 11.6429C4.713 11.6429 3.85714 10.787 3.85714 9.71429C3.85714 8.64157 4.713 7.78571 5.78571 7.78571Z"
      fill="currentColor"
    />
  </svg>
)
